// src/pages/Proposals/FileDialog/forms/common/InstitutionSelect.js
import React from "react";
import PropTypes from "prop-types";
import EntitySelect from "../common/EntitySelect";

function InstitutionSelect({ value, onChange, label = "Institution", sx }) {
  return (
    <EntitySelect
      value={value}
      onChange={onChange}
      endpoint="/institution/"
      label={label}
      getOptionLabel={(opt) => opt?.name || ""}
      searchParam="search"
      sx={sx}
    />
  );
}
InstitutionSelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  sx: PropTypes.object,
};
InstitutionSelect.defaultProps = { value: null, label: "Institution", sx: {} };

export default React.memo(InstitutionSelect);
